import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { ServicenumberListComponent } from '../servicenumber/list/servicenumber-list.component';

@Component({
  selector: 'app-tenant-servicenumber-page',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ServicenumberListComponent, TestIdDirective],
  template: `
    <div class="tenant-servicenumber-page" testId="tenant-servicenumber-page">
      <ng-container *ngIf="!hasDetailPane; else detailTpl">
        <app-servicenumber-list
          [tenantId]="tenantId"
          [tenantType]="tenantType"
          [viewMode]="'card'"
          pageTitleKey="menu.servicenumber-management"
        />
      </ng-container>

      <ng-template #detailTpl>
        <div class="detail-pane">
          <router-outlet />
        </div>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .tenant-servicenumber-page {
        min-width: 0;
      }

      .detail-pane {
        overflow: hidden;
        border-radius: 12px;
      }
    `
  ]
})
export class TenantServicenumberPageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '';
  readonly tenantType = this.readCurrentTenantType();

  get hasDetailPane(): boolean {
    return this.route.firstChild != null;
  }

  private readCurrentTenantType(): string {
    try {
      const value = localStorage.getItem('current_tenant');
      return value ? (JSON.parse(value)?.type ?? '') : '';
    } catch {
      return '';
    }
  }
}
